import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../../styles/exportExcelPopup.module.css";

function ExportExcelPopup({ isOpen, onClose, exportOptions, onExportOptionsChange, onConfirmExport }) {
    const { t } = useTranslation();

    if (!isOpen) return null;

    const handleClickOutside = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    const handleConfirm = () => {
        onConfirmExport();
        onClose();
    };

    return (
        <div className={styles.popupOverlay} onClick={handleClickOutside}>
            <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
                <h2>{t("exportOptions")}</h2>
                <p className={styles.subtitle}>{t("exportOptionsSubtitle")}</p>
                <div className={styles.optionsGrid}>
                    <div className={styles.optionGroup}>
                        <label>{t("dataType")}</label>
                        <select
                            value={exportOptions.tipoDatos}
                            onChange={(e) => onExportOptionsChange("tipoDatos", e.target.value)}
                            disabled={exportOptions.calcularMedia}
                        >
                            <option value="conNombre">{t("withName")}</option>
                            <option value="anonimo">{t("anonymous")}</option>
                        </select>
                    </div>
                    <div className={styles.optionGroup}>
                        <label>{t("dimension")}</label>
                        <select
                            value={exportOptions.nivelDatos}
                            onChange={(e) => onExportOptionsChange("nivelDatos", e.target.value)}
                        >
                            <option value="personal">{t("personal")}</option>
                            <option value="equipo">{t("team")}</option>
                            <option value="ambos">{t("both")}</option>
                        </select>
                    </div>
                    <div className={styles.optionGroup}>
                        <label>{t("calculateAverage")}</label>
                        <input
                            type="checkbox"
                            checked={exportOptions.calcularMedia}
                            onChange={(e) => onExportOptionsChange("calcularMedia", e.target.checked)}
                        />
                    </div>
                    <div className={styles.optionGroup}>
                        <label>{t("sortBy")}</label>
                        <select
                            value={exportOptions.ordenarPor}
                            onChange={(e) => onExportOptionsChange("ordenarPor", e.target.value)}
                        >
                            <option value="pregunta">{t("scope")}</option>
                            <option value="puntuacion">{t("score")}</option>
                        </select>
                    </div>
                    <div className={styles.optionGroup}>
                        <label>{t("order")}</label>
                        <select
                            value={exportOptions.orden}
                            onChange={(e) => onExportOptionsChange("orden", e.target.value)}
                        >
                            <option value="ascendente">{t("ascending")}</option>
                            <option value="descendente">{t("descending")}</option>
                        </select>
                    </div>
                </div>
                <div className={styles.popupActions}>
                    <button type="button" className={styles.buttonCancel} onClick={onClose}>
                        {t("cancel")}
                    </button>
                    <button type="button" className={styles.buttonExport} onClick={handleConfirm}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20">
                            <path fill="#169154" d="M29,6H15.744C14.781,6,14,6.781,14,7.744v7.259h15V6z" />
                            <path fill="#18482a" d="M14,33.054v7.202C14,41.219,14.781,42,15.743,42H29v-8.946H14z" />
                            <path fill="#0c8045" d="M14 15.003H29V24.005000000000003H14z" />
                            <path fill="#17472a" d="M14 24.005H29V33.055H14z" />
                            <g>
                                <path fill="#29c27f" d="M42.256,6H29v9.003h15V7.744C44,6.781,43.219,6,42.256,6z" />
                                <path fill="#27663f" d="M29,33.054V42h13.257C43.219,42,44,41.219,44,40.257v-7.202H29z" />
                                <path fill="#19ac65" d="M29 15.003H44V24.005000000000003H29z" />
                                <path fill="#129652" d="M29 24.005H44V33.055H29z" />
                            </g>
                            <path fill="#0c7238" d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z" />
                            <path fill="#fff" d="M9.807 19L12.193 19 14.129 22.754 16.175 19 18.404 19 15.333 24 18.474 29 16.123 29 14.013 25.07 11.912 29 9.526 29 12.719 23.982z" />
                        </svg>
                        {t("export")}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ExportExcelPopup;
